// export const url = "https://apibilling.opentech4u.co.in:3005"
// export const url = "https://apibilling.opentech4u.co.in:3010";

// export const url_for_image = "http://202.21.38.178:3001";
// export const url = "http://202.21.38.178:3001/v2";



// export const url = "http://98.130.88.168:3002";
// export const url = "https://estimateapi.opentech4u.co.in";

// export const url = "http://98.130.88.168:3001/v2";

// export const url_for_image = "http://192.168.1.32:3001";
// export const url = "http://192.168.1.204:3002/v2";  // Development URL
// export const url = "http://192.168.1.240:3001/v2"

export const url = "https://estimateapi.opentech4u.co.in/v2";
export const url_for_image = "https://estimateapi.opentech4u.co.in/uploads/";





